import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface ColumnTableWrapperProps {
  children: React.ReactNode;
  icon?: LucideIcon;
  className?: string;
}

export function ColumnTableWrapper({ children, icon: Icon, className }: ColumnTableWrapperProps) {
  return (
    <div className="flex items-center gap-1.5 text-sm font-medium text-foreground">
      {Icon && <Icon className="max-h-4 min-h-4 min-w-4 max-w-4 text-primary" />}
      <span className={cn("truncate text-sm", className)}>{children}</span>
    </div>
  );
}
